export function saveAccount(account) {
  localStorage.setItem('account_key', account)
}
export function readAccount() {
  return localStorage.getItem('account_key') || ''
}